import React, { Component } from 'react';
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import  Interweave from 'interweave';
class ModalPopup extends Component {
  state = {
    modal: true
  };

  toggle = () => {
   // this.props.closeModal()
   // this.props.handleClose()
   this.setState({modal:false})
  }
  render() {
    
    return (
      <MDBContainer>
        <MDBModal isOpen={this.state.modal}   toggle={this.toggle} centered  >
          <MDBModalHeader className="default-color gothamBlack m-1 white-text" toggle={this.toggle}>{this.props.title}</MDBModalHeader>
          <MDBModalBody>
            
          {this.props.body && <Interweave content= {String(this.props.body)} />}
           
          </MDBModalBody>
          <MDBModalFooter>
            {this.props.showClose && this.props.showClose!=false && <MDBBtn size='sm' className="btn-dark-green" onClick={this.toggle}>Close</MDBBtn>}
          </MDBModalFooter>
        </MDBModal>
      </MDBContainer>
    );
  }
}
export default ModalPopup;